// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ch0G","containerItemsCenter":"Skeleton_containerItemsCenter__1v5lN"};